import {
  Chart,
  ArcElement,
  DoughnutController,
  CategoryScale,
  LinearScale,
  BarController,
  BarElement,
  Tooltip
} from 'chart.js'

Chart.register(
  ArcElement,
  DoughnutController,
  CategoryScale,
  LinearScale,
  BarController,
  BarElement,
  Tooltip
)

const COLOR_PRIMARY = '#17365C'
const COLOR_GREEN = '#8DAE10'
const COLOR_GREY = '#9E9E9E'
const GRID_COLOR = 'rgba(0, 0, 0, 0.06)'

function formatNumber (value, locale) {
  return value.toLocaleString(locale)
}

function genderColor (key) {
  if (key === 'male') return COLOR_PRIMARY
  if (key === 'female') return COLOR_GREEN
  if (key === 'diverse') return COLOR_GREEN
  return COLOR_GREY
}

function caseColor (key) {
  if (key === 'inpatient') return COLOR_PRIMARY
  if (key === 'outpatient') return COLOR_GREEN
  return COLOR_GREY
}

function initGenderChart (container, genderData, locale, tooltipPatients) {
  const canvas = container.querySelector('#zdm-gender-chart')
  if (!canvas || !genderData.length) return

  const colors = genderData.map(function (item) { return genderColor(item.key) })
  const total = genderData.reduce(function (sum, item) { return sum + item.value }, 0)

  const legendContainer = container.querySelector('#zdm-gender-legend')
  if (legendContainer) {
    legendContainer.innerHTML = genderData.map(function (item, i) {
      const pct = total > 0 ? Math.round((item.value / total) * 100) : 0
      return '<span class="zdm-dashboard__legend-item">' +
        '<span class="zdm-dashboard__legend-dot" style="background:' + colors[i] + '"></span>' +
        '<span>' + item.label + '</span>' +
        '<span class="zdm-dashboard__legend-pct">' + pct + '\u00a0%</span>' +
        '</span>'
    }).join('')
  }

  // eslint-disable-next-line no-new
  new Chart(canvas, {
    type: 'doughnut',
    data: {
      labels: genderData.map(function (item) { return item.label }),
      datasets: [{
        data: genderData.map(function (item) { return item.value }),
        backgroundColor: colors,
        borderWidth: 0,
        hoverOffset: 4
      }]
    },
    options: {
      cutout: '62%',
      plugins: {
        legend: { display: false },
        tooltip: {
          callbacks: {
            label: function (ctx) { return ' ' + formatNumber(ctx.parsed, locale) + ' ' + tooltipPatients }
          }
        }
      },
      responsive: true,
      maintainAspectRatio: false
    }
  })
}

function initAgeChart (container, ageData, locale, tooltipPatients) {
  const canvas = container.querySelector('#zdm-age-chart')
  if (!canvas || !ageData.length) return

  // eslint-disable-next-line no-new
  new Chart(canvas, {
    type: 'bar',
    data: {
      labels: ageData.map(function (item) { return item.label }),
      datasets: [{
        data: ageData.map(function (item) { return item.value }),
        backgroundColor: COLOR_PRIMARY,
        borderRadius: 4,
        borderWidth: 0
      }]
    },
    options: {
      plugins: {
        legend: { display: false },
        tooltip: {
          callbacks: {
            label: function (ctx) { return ' ' + formatNumber(ctx.parsed.y, locale) + ' ' + tooltipPatients }
          }
        }
      },
      scales: {
        x: {
          grid: { display: false },
          ticks: {
            maxRotation: 45,
            minRotation: 0,
            autoSkip: true,
            maxTicksLimit: 11
          }
        },
        y: {
          grid: { color: GRID_COLOR },
          ticks: { callback: function (value) { return formatNumber(value, locale) } }
        }
      },
      responsive: true,
      maintainAspectRatio: false
    }
  })
}

function initCasesChart (container, caseTypeData, locale, tooltipCases) {
  const canvas = container.querySelector('#zdm-cases-chart')
  if (!canvas || !caseTypeData.length) return

  const bgColors = caseTypeData.map(function (item) { return caseColor(item.key) })

  const legendContainer = container.querySelector('#zdm-cases-legend')
  if (legendContainer) {
    legendContainer.innerHTML = caseTypeData.map(function (item, i) {
      return '<span class="zdm-dashboard__legend-item">' +
        '<span class="zdm-dashboard__legend-dot" style="background:' + bgColors[i] + '"></span>' +
        '<span>' + item.label + '</span>' +
        '<span class="zdm-dashboard__legend-value">' + formatNumber(item.value, locale) + '</span>' +
        '</span>'
    }).join('')
  }

  // eslint-disable-next-line no-new
  new Chart(canvas, {
    type: 'bar',
    data: {
      labels: caseTypeData.map(function (item) { return item.label }),
      datasets: [{
        data: caseTypeData.map(function (item) { return item.value }),
        backgroundColor: bgColors,
        borderRadius: 4,
        borderWidth: 0
      }]
    },
    options: {
      indexAxis: 'y',
      plugins: {
        legend: { display: false },
        tooltip: {
          callbacks: {
            label: function (ctx) { return ' ' + formatNumber(ctx.parsed.x, locale) + ' ' + tooltipCases }
          }
        }
      },
      scales: {
        x: {
          grid: { color: GRID_COLOR },
          ticks: {
            callback: function (value) { return formatNumber(value, locale) },
            maxTicksLimit: 6
          }
        },
        y: { grid: { display: false } }
      },
      responsive: true,
      maintainAspectRatio: false
    }
  })
}

function initDashboard (container) {
  const genderData = JSON.parse(container.dataset.zdmGender || '[]')
  const ageData = JSON.parse(container.dataset.zdmAge || '[]')
  const caseTypeData = JSON.parse(container.dataset.zdmCases || '[]')
  const locale = container.dataset.zdmLocale || 'de-DE'
  const tooltipPatients = container.dataset.zdmTooltipPatients || 'Patienten'
  const tooltipCases = container.dataset.zdmTooltipCases || 'Fälle'

  initGenderChart(container, genderData, locale, tooltipPatients)
  initAgeChart(container, ageData, locale, tooltipPatients)
  initCasesChart(container, caseTypeData, locale, tooltipCases)
}

window.addEventListener('load', function () {
  document.querySelectorAll('[data-js-zdm-dashboard]').forEach(initDashboard)
})
